export default "__VITE_PUBLIC_ASSET__96d8c0fc__"